interface Props {
	children: React.ReactNode;
}
const AuthWrap = ({ children }: Props) => {
	return <div className="w-full max-w-md px-2 mx-auto my-4 gap-y-4">{children}</div>;
};

export default AuthWrap;
